import React from "react";

import { useTranslation } from "react-i18next";

import type { JSX } from "react";

interface DataTableSrOnlyHeaderProps {
  labelKey: "dataTable.actions" | "dataTable.reorder";
}

function DataTableSrOnlyHeader({
  labelKey,
}: DataTableSrOnlyHeaderProps): JSX.Element {
  const { t } = useTranslation("table");

  return <span className="sr-only">{t(labelKey)}</span>;
}

export default DataTableSrOnlyHeader;
